import { useEffect, useState } from "react";
import { getStore } from "@/lib/api";
import { Overline } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";
import { Reveal } from "@/lib/reveal";

const CATS = ["All", "Seeds", "Bread Kits", "Canning Kits", "Herbs & Spices"];

export default function Store() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => { getStore().then(setProducts).catch(() => {}); }, []);
  const shown = cat === "All" ? products : products.filter((p) => p.category === cat);

  return (
    <div data-testid="store-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10 text-center">
        <Overline>Wares from the cottage</Overline>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light mt-5 mb-6 leading-none">The Cottage Store</h1>
        <p className="font-body text-brand-body text-lg leading-relaxed max-w-2xl mx-auto">
          Seeds for the garden, kits for the kitchen, and herbs for the pantry — the honest, well-made things Agnes
          keeps close. Our first collection is being gathered now and will be posted to your door soon.
        </p>
      </section>

      <div className="flex flex-wrap justify-center gap-3 px-6 mb-16">
        {CATS.map((c) => (
          <button key={c} data-testid={`store-filter-${c}`} onClick={() => setCat(c)}
            className={`font-sans text-[0.72rem] uppercase tracking-[0.14em] px-5 py-2 border transition-colors duration-300 ${cat === c ? "bg-brand-olive text-brand-cream border-brand-olive" : "border-brand-linen text-brand-body hover:border-brand-gold"}`}>
            {c}
          </button>
        ))}
      </div>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {shown.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.07}>
              <div className="group" data-testid={`store-card-${p.slug}`}>
                <div className="overflow-hidden bg-brand-warm-white border border-brand-linen relative">
                  <img src={p.image} alt={p.title} className="w-full aspect-square object-cover opacity-80 group-hover:scale-[1.04] transition-transform duration-700" />
                  <span className="absolute top-4 left-4 bg-brand-olive text-brand-cream font-sans text-[0.6rem] uppercase tracking-[0.16em] px-3 py-1.5">Coming Soon</span>
                </div>
                <div className="pt-5">
                  <span className="overline text-[0.6rem]">{p.category}</span>
                  <h3 className="font-serif text-2xl mt-2 leading-snug">{p.title}</h3>
                  <p className="font-body text-brand-muted mt-1 leading-relaxed">{p.blurb}</p>
                  <div className="flex items-center justify-end mt-4">
                    <span data-testid={`coming-soon-${p.slug}`}
                      className="inline-flex items-center gap-2 border border-brand-linen text-brand-muted px-5 py-2.5 font-sans text-[0.66rem] uppercase tracking-[0.14em] cursor-default">
                      Coming Soon
                    </span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <NewsletterSection />
    </div>
  );
}
